import axios from '@/api/axios'

const getActionsMagazineByParams = (params) => {
  return axios.get(`/action-log${params}`).then((response) => response.data)
}

const getActionsMagazine = (id) => {
  return axios.get(`/action-log/${id}`)
}

export default {
  getActionsMagazine,
  getActionsMagazineByParams,
}
